import{Dropzone as e}from"./src/Dropzone.js";customElements.define("sp-dropzone",e);
//# sourceMappingURL=sp-dropzone.js.map
